import ExpansionPanels from 'www/modules/ExpansionPanels'
import YaGoals from 'www/modules/YandexGoals'
import { getNamespace } from 'www/modules/ExpansionPanels/functions'

const instanceYaGoals = new YaGoals()

function initExpansionPanels() {
  const expansionPanelElements = [...document.querySelectorAll('.b-services-expansion-panels')]

  expansionPanelElements.forEach(expansionPanelElement => {
    const { head: headClassName } = getNamespace()

    new ExpansionPanels({
      target: expansionPanelElement,
      hasArrow: false,
      hookBeforeAnimateStart() {
        this.target.querySelector(`.${headClassName}`).classList.add('d-none')
      },
      hookAfterAnimateEnd({ isExpand }) {
        if (isExpand) {
          instanceYaGoals.send({
            name: 'servicesExpansionPanels__pricesExpand',
          })
        }
      },
    })
  })
}

document.addEventListener('DOMContentLoaded', initExpansionPanels, false)
document.addEventListener('content-replace', initExpansionPanels, false)
